/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddSlotsBody } from '../models';
// @ts-ignore
import type { AvailabilityCandidateView } from '../models';
// @ts-ignore
import type { AvailabilityDetailResponse } from '../models';
// @ts-ignore
import type { AvailabilityTemplateResponse } from '../models';
// @ts-ignore
import type { BookGuidanceSlotBody } from '../models';
// @ts-ignore
import type { BookSlotBody } from '../models';
// @ts-ignore
import type { CancelGuidanceCallBody } from '../models';
// @ts-ignore
import type { CancelInterviewBody } from '../models';
// @ts-ignore
import type { CreateAvailabilityBody } from '../models';
// @ts-ignore
import type { CreateGuidanceSlotsBody } from '../models';
// @ts-ignore
import type { CreateGuidanceSlotsResponse } from '../models';
// @ts-ignore
import type { CreateTemplateBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetAdminRecordingsResponse } from '../models';
// @ts-ignore
import type { GetAvailabilitiesResponse } from '../models';
// @ts-ignore
import type { GetGuidanceSessionsResponse } from '../models';
// @ts-ignore
import type { GetGuidanceSlotsResponse } from '../models';
// @ts-ignore
import type { GetInterviewsResponse } from '../models';
// @ts-ignore
import type { GetTemplatesResponse } from '../models';
// @ts-ignore
import type { GuidanceConfigResponse } from '../models';
// @ts-ignore
import type { GuidanceOverviewResponse } from '../models';
// @ts-ignore
import type { GuidanceSession } from '../models';
// @ts-ignore
import type { Interview } from '../models';
// @ts-ignore
import type { InterviewDetailResponse } from '../models';
// @ts-ignore
import type { JoinInterviewResponse } from '../models';
// @ts-ignore
import type { LeaveInterviewResponse } from '../models';
// @ts-ignore
import type { RecordingResponse } from '../models';
// @ts-ignore
import type { RescheduleGuidanceBody } from '../models';
// @ts-ignore
import type { RescheduleInterviewBody } from '../models';
// @ts-ignore
import type { RespondInterviewBody } from '../models';
// @ts-ignore
import type { ScheduleInterviewBody } from '../models';
// @ts-ignore
import type { SendAvailabilityBody } from '../models';
// @ts-ignore
import type { SendFromTemplateBody } from '../models';
// @ts-ignore
import type { SendGuidanceReminderBody } from '../models';
// @ts-ignore
import type { SetGuidanceConfigBody } from '../models';
// @ts-ignore
import type { TranscriptResponse } from '../models';
// @ts-ignore
import type { UpdateInterviewSettingsBody } from '../models';
// @ts-ignore
import type { UpdateTemplateBody } from '../models';
/**
 * InterviewApiApi - axios parameter creator
 */
export const InterviewApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} availabilityId 
         * @param {string} orgId 
         * @param {AddSlotsBody} addSlotsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiAddAvailabilitySlots: async (availabilityId: string, orgId: string, addSlotsBody: AddSlotsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilityId' is not null or undefined
            assertParamExists('interviewApiAddAvailabilitySlots', 'availabilityId', availabilityId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiAddAvailabilitySlots', 'orgId', orgId)
            // verify required parameter 'addSlotsBody' is not null or undefined
            assertParamExists('interviewApiAddAvailabilitySlots', 'addSlotsBody', addSlotsBody)
            const localVarPath = `/org/{org_id}/interview-availability/{availability_id}/slots`
                .replace('{availability_id}', encodeURIComponent(String(availabilityId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSlotsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {string} orgId 
         * @param {string} pid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiAdmitParticipant: async (interviewId: string, orgId: string, pid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiAdmitParticipant', 'interviewId', interviewId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiAdmitParticipant', 'orgId', orgId)
            // verify required parameter 'pid' is not null or undefined
            assertParamExists('interviewApiAdmitParticipant', 'pid', pid)
            const localVarPath = `/org/{org_id}/interview/{interview_id}/participants/{pid}/admit`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{pid}', encodeURIComponent(String(pid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} availabilityId 
         * @param {BookSlotBody} bookSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiBookAvailabilitySlot: async (availabilityId: string, bookSlotBody: BookSlotBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilityId' is not null or undefined
            assertParamExists('interviewApiBookAvailabilitySlot', 'availabilityId', availabilityId)
            // verify required parameter 'bookSlotBody' is not null or undefined
            assertParamExists('interviewApiBookAvailabilitySlot', 'bookSlotBody', bookSlotBody)
            const localVarPath = `/interview-availability/{availability_id}/book`
                .replace('{availability_id}', encodeURIComponent(String(availabilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookSlotBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slotId 
         * @param {BookGuidanceSlotBody} bookGuidanceSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiBookGuidanceSlot: async (slotId: string, bookGuidanceSlotBody: BookGuidanceSlotBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slotId' is not null or undefined
            assertParamExists('interviewApiBookGuidanceSlot', 'slotId', slotId)
            // verify required parameter 'bookGuidanceSlotBody' is not null or undefined
            assertParamExists('interviewApiBookGuidanceSlot', 'bookGuidanceSlotBody', bookGuidanceSlotBody)
            const localVarPath = `/guidance/slots/{slot_id}/book`
                .replace('{slot_id}', encodeURIComponent(String(slotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookGuidanceSlotBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {CancelGuidanceCallBody} cancelGuidanceCallBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiCancelAdminGuidanceCall: async (interviewId: string, cancelGuidanceCallBody: CancelGuidanceCallBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiCancelAdminGuidanceCall', 'interviewId', interviewId)
            // verify required parameter 'cancelGuidanceCallBody' is not null or undefined
            assertParamExists('interviewApiCancelAdminGuidanceCall', 'cancelGuidanceCallBody', cancelGuidanceCallBody)
            const localVarPath = `/admin/guidance/sessions/{interview_id}/cancel`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelGuidanceCallBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiCancelGuidanceReminder: async (interviewId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiCancelGuidanceReminder', 'interviewId', interviewId)
            const localVarPath = `/admin/guidance/sessions/{interview_id}/remind`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {string} orgId 
         * @param {CancelInterviewBody} cancelInterviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiCancelInterview: async (interviewId: string, orgId: string, cancelInterviewBody: CancelInterviewBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiCancelInterview', 'interviewId', interviewId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiCancelInterview', 'orgId', orgId)
            // verify required parameter 'cancelInterviewBody' is not null or undefined
            assertParamExists('interviewApiCancelInterview', 'cancelInterviewBody', cancelInterviewBody)
            const localVarPath = `/org/{org_id}/interview/{interview_id}/cancel`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelInterviewBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiCancelMyGuidanceCall: async (interviewId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiCancelMyGuidanceCall', 'interviewId', interviewId)
            const localVarPath = `/guidance/sessions/{interview_id}/cancel`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} availabilityId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiCloseAvailability: async (availabilityId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilityId' is not null or undefined
            assertParamExists('interviewApiCloseAvailability', 'availabilityId', availabilityId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiCloseAvailability', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/interview-availability/{availability_id}/close`
                .replace('{availability_id}', encodeURIComponent(String(availabilityId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateGuidanceSlotsBody} createGuidanceSlotsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiCreateAdminGuidanceSlots: async (createGuidanceSlotsBody: CreateGuidanceSlotsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createGuidanceSlotsBody' is not null or undefined
            assertParamExists('interviewApiCreateAdminGuidanceSlots', 'createGuidanceSlotsBody', createGuidanceSlotsBody)
            const localVarPath = `/admin/guidance/slots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGuidanceSlotsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateAvailabilityBody} createAvailabilityBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiCreateAvailability: async (orgId: string, createAvailabilityBody: CreateAvailabilityBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiCreateAvailability', 'orgId', orgId)
            // verify required parameter 'createAvailabilityBody' is not null or undefined
            assertParamExists('interviewApiCreateAvailability', 'createAvailabilityBody', createAvailabilityBody)
            const localVarPath = `/org/{org_id}/interview-availability`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAvailabilityBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateTemplateBody} createTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiCreateAvailabilityTemplate: async (orgId: string, createTemplateBody: CreateTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiCreateAvailabilityTemplate', 'orgId', orgId)
            // verify required parameter 'createTemplateBody' is not null or undefined
            assertParamExists('interviewApiCreateAvailabilityTemplate', 'createTemplateBody', createTemplateBody)
            const localVarPath = `/org/{org_id}/interview-availability-template`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiDeleteAdminGuidanceSlot: async (slotId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slotId' is not null or undefined
            assertParamExists('interviewApiDeleteAdminGuidanceSlot', 'slotId', slotId)
            const localVarPath = `/admin/guidance/slots/{slot_id}`
                .replace('{slot_id}', encodeURIComponent(String(slotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiDeleteAvailabilityTemplate: async (orgId: string, templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiDeleteAvailabilityTemplate', 'orgId', orgId)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('interviewApiDeleteAvailabilityTemplate', 'templateId', templateId)
            const localVarPath = `/org/{org_id}/interview-availability-template/{template_id}`
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {boolean | null} [upcoming] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetAdminGuidanceSessions: async (page?: number, pageSize?: number, upcoming?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/guidance/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (upcoming !== undefined) {
                localVarQueryParameter['upcoming'] = upcoming;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [includeAll] 
         * @param {string | null} [meetingType] 
         * @param {string | null} [orgId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [recordingStatus] 
         * @param {string | null} [transcriptStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetAdminInterviewRecordings: async (includeAll?: boolean, meetingType?: string | null, orgId?: string | null, page?: number, pageSize?: number, recordingStatus?: string | null, transcriptStatus?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/interview/recordings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeAll !== undefined) {
                localVarQueryParameter['include_all'] = includeAll;
            }

            if (meetingType !== undefined) {
                localVarQueryParameter['meeting_type'] = meetingType;
            }

            if (orgId !== undefined) {
                localVarQueryParameter['org_id'] = orgId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (recordingStatus !== undefined) {
                localVarQueryParameter['recording_status'] = recordingStatus;
            }

            if (transcriptStatus !== undefined) {
                localVarQueryParameter['transcript_status'] = transcriptStatus;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetAdminInterviewTranscript: async (interviewId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiGetAdminInterviewTranscript', 'interviewId', interviewId)
            const localVarPath = `/admin/interview/{interview_id}/transcript`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string | null} [jobId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetAvailabilities: async (orgId: string, jobId?: string | null, page?: number, pageSize?: number, status?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiGetAvailabilities', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/interview-availability`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (jobId !== undefined) {
                localVarQueryParameter['job_id'] = jobId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} availabilityId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetAvailability: async (availabilityId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilityId' is not null or undefined
            assertParamExists('interviewApiGetAvailability', 'availabilityId', availabilityId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiGetAvailability', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/interview-availability/{availability_id}`
                .replace('{availability_id}', encodeURIComponent(String(availabilityId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} availabilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetAvailabilityForCandidate: async (availabilityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilityId' is not null or undefined
            assertParamExists('interviewApiGetAvailabilityForCandidate', 'availabilityId', availabilityId)
            const localVarPath = `/interview-availability/{availability_id}`
                .replace('{availability_id}', encodeURIComponent(String(availabilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetAvailabilityTemplates: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiGetAvailabilityTemplates', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/interview-availability-template`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetGuidanceOverview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/guidance/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {boolean | null} [consent] 
         * @param {string | null} [displayName] 
         * @param {string | null} [st] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetInterview: async (interviewId: string, consent?: boolean | null, displayName?: string | null, st?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiGetInterview', 'interviewId', interviewId)
            const localVarPath = `/interview/{interview_id}`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (consent !== undefined) {
                localVarQueryParameter['consent'] = consent;
            }

            if (displayName !== undefined) {
                localVarQueryParameter['display_name'] = displayName;
            }

            if (st !== undefined) {
                localVarQueryParameter['st'] = st;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetInterviewRecording: async (interviewId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiGetInterviewRecording', 'interviewId', interviewId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiGetInterviewRecording', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/interview/{interview_id}/recording`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [jobId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [status] 
         * @param {boolean | null} [upcoming] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetMyInterviews: async (jobId?: string | null, page?: number, pageSize?: number, status?: string | null, upcoming?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/interview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (jobId !== undefined) {
                localVarQueryParameter['job_id'] = jobId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (upcoming !== undefined) {
                localVarQueryParameter['upcoming'] = upcoming;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string | null} [candidateUserId] 
         * @param {string | null} [jobId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [status] 
         * @param {boolean | null} [upcoming] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetOrgInterviews: async (orgId: string, candidateUserId?: string | null, jobId?: string | null, page?: number, pageSize?: number, status?: string | null, upcoming?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiGetOrgInterviews', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/interview`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (candidateUserId !== undefined) {
                localVarQueryParameter['candidate_user_id'] = candidateUserId;
            }

            if (jobId !== undefined) {
                localVarQueryParameter['job_id'] = jobId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (upcoming !== undefined) {
                localVarQueryParameter['upcoming'] = upcoming;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {boolean | null} [consent] 
         * @param {string | null} [displayName] 
         * @param {string | null} [st] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiJoinInterview: async (interviewId: string, consent?: boolean | null, displayName?: string | null, st?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiJoinInterview', 'interviewId', interviewId)
            const localVarPath = `/interview/{interview_id}/join`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (consent !== undefined) {
                localVarQueryParameter['consent'] = consent;
            }

            if (displayName !== undefined) {
                localVarQueryParameter['display_name'] = displayName;
            }

            if (st !== undefined) {
                localVarQueryParameter['st'] = st;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {boolean | null} [consent] 
         * @param {string | null} [displayName] 
         * @param {string | null} [st] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiLeaveInterview: async (interviewId: string, consent?: boolean | null, displayName?: string | null, st?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiLeaveInterview', 'interviewId', interviewId)
            const localVarPath = `/interview/{interview_id}/leave`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (consent !== undefined) {
                localVarQueryParameter['consent'] = consent;
            }

            if (displayName !== undefined) {
                localVarQueryParameter['display_name'] = displayName;
            }

            if (st !== undefined) {
                localVarQueryParameter['st'] = st;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiListAdminGuidanceSlots: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/guidance/slots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiMarkAdminGuidanceNoShow: async (interviewId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiMarkAdminGuidanceNoShow', 'interviewId', interviewId)
            const localVarPath = `/admin/guidance/sessions/{interview_id}/no-show`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} availabilityId 
         * @param {string} orgId 
         * @param {string} slotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiRemoveAvailabilitySlot: async (availabilityId: string, orgId: string, slotId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilityId' is not null or undefined
            assertParamExists('interviewApiRemoveAvailabilitySlot', 'availabilityId', availabilityId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiRemoveAvailabilitySlot', 'orgId', orgId)
            // verify required parameter 'slotId' is not null or undefined
            assertParamExists('interviewApiRemoveAvailabilitySlot', 'slotId', slotId)
            const localVarPath = `/org/{org_id}/interview-availability/{availability_id}/slots/{slot_id}`
                .replace('{availability_id}', encodeURIComponent(String(availabilityId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{slot_id}', encodeURIComponent(String(slotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {string} orgId 
         * @param {string} pid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiRemoveParticipant: async (interviewId: string, orgId: string, pid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiRemoveParticipant', 'interviewId', interviewId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiRemoveParticipant', 'orgId', orgId)
            // verify required parameter 'pid' is not null or undefined
            assertParamExists('interviewApiRemoveParticipant', 'pid', pid)
            const localVarPath = `/org/{org_id}/interview/{interview_id}/participants/{pid}/remove`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{pid}', encodeURIComponent(String(pid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {string} orgId 
         * @param {RescheduleInterviewBody} rescheduleInterviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiRescheduleInterview: async (interviewId: string, orgId: string, rescheduleInterviewBody: RescheduleInterviewBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiRescheduleInterview', 'interviewId', interviewId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiRescheduleInterview', 'orgId', orgId)
            // verify required parameter 'rescheduleInterviewBody' is not null or undefined
            assertParamExists('interviewApiRescheduleInterview', 'rescheduleInterviewBody', rescheduleInterviewBody)
            const localVarPath = `/org/{org_id}/interview/{interview_id}/reschedule`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rescheduleInterviewBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {RescheduleGuidanceBody} rescheduleGuidanceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiRescheduleMyGuidanceCall: async (interviewId: string, rescheduleGuidanceBody: RescheduleGuidanceBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiRescheduleMyGuidanceCall', 'interviewId', interviewId)
            // verify required parameter 'rescheduleGuidanceBody' is not null or undefined
            assertParamExists('interviewApiRescheduleMyGuidanceCall', 'rescheduleGuidanceBody', rescheduleGuidanceBody)
            const localVarPath = `/guidance/sessions/{interview_id}/reschedule`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rescheduleGuidanceBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {RespondInterviewBody} respondInterviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiRespondInterview: async (interviewId: string, respondInterviewBody: RespondInterviewBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiRespondInterview', 'interviewId', interviewId)
            // verify required parameter 'respondInterviewBody' is not null or undefined
            assertParamExists('interviewApiRespondInterview', 'respondInterviewBody', respondInterviewBody)
            const localVarPath = `/interview/{interview_id}/respond`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(respondInterviewBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {ScheduleInterviewBody} scheduleInterviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiScheduleInterview: async (orgId: string, scheduleInterviewBody: ScheduleInterviewBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiScheduleInterview', 'orgId', orgId)
            // verify required parameter 'scheduleInterviewBody' is not null or undefined
            assertParamExists('interviewApiScheduleInterview', 'scheduleInterviewBody', scheduleInterviewBody)
            const localVarPath = `/org/{org_id}/interview`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scheduleInterviewBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} availabilityId 
         * @param {string} orgId 
         * @param {SendAvailabilityBody} sendAvailabilityBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiSendAvailability: async (availabilityId: string, orgId: string, sendAvailabilityBody: SendAvailabilityBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilityId' is not null or undefined
            assertParamExists('interviewApiSendAvailability', 'availabilityId', availabilityId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiSendAvailability', 'orgId', orgId)
            // verify required parameter 'sendAvailabilityBody' is not null or undefined
            assertParamExists('interviewApiSendAvailability', 'sendAvailabilityBody', sendAvailabilityBody)
            const localVarPath = `/org/{org_id}/interview-availability/{availability_id}/send`
                .replace('{availability_id}', encodeURIComponent(String(availabilityId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendAvailabilityBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} templateId 
         * @param {SendFromTemplateBody} sendFromTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiSendAvailabilityFromTemplate: async (orgId: string, templateId: string, sendFromTemplateBody: SendFromTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiSendAvailabilityFromTemplate', 'orgId', orgId)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('interviewApiSendAvailabilityFromTemplate', 'templateId', templateId)
            // verify required parameter 'sendFromTemplateBody' is not null or undefined
            assertParamExists('interviewApiSendAvailabilityFromTemplate', 'sendFromTemplateBody', sendFromTemplateBody)
            const localVarPath = `/org/{org_id}/interview-availability-template/{template_id}/send`
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendFromTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {SendGuidanceReminderBody} sendGuidanceReminderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiSendGuidanceJoinReminder: async (interviewId: string, sendGuidanceReminderBody: SendGuidanceReminderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiSendGuidanceJoinReminder', 'interviewId', interviewId)
            // verify required parameter 'sendGuidanceReminderBody' is not null or undefined
            assertParamExists('interviewApiSendGuidanceJoinReminder', 'sendGuidanceReminderBody', sendGuidanceReminderBody)
            const localVarPath = `/admin/guidance/sessions/{interview_id}/remind`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendGuidanceReminderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetGuidanceConfigBody} setGuidanceConfigBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiSetAdminGuidanceConfig: async (setGuidanceConfigBody: SetGuidanceConfigBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setGuidanceConfigBody' is not null or undefined
            assertParamExists('interviewApiSetAdminGuidanceConfig', 'setGuidanceConfigBody', setGuidanceConfigBody)
            const localVarPath = `/admin/guidance/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setGuidanceConfigBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiUnlockInterviewRecording: async (interviewId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiUnlockInterviewRecording', 'interviewId', interviewId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiUnlockInterviewRecording', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/interview/{interview_id}/recording/unlock`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} templateId 
         * @param {UpdateTemplateBody} updateTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiUpdateAvailabilityTemplate: async (orgId: string, templateId: string, updateTemplateBody: UpdateTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiUpdateAvailabilityTemplate', 'orgId', orgId)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('interviewApiUpdateAvailabilityTemplate', 'templateId', templateId)
            // verify required parameter 'updateTemplateBody' is not null or undefined
            assertParamExists('interviewApiUpdateAvailabilityTemplate', 'updateTemplateBody', updateTemplateBody)
            const localVarPath = `/org/{org_id}/interview-availability-template/{template_id}`
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {string} orgId 
         * @param {UpdateInterviewSettingsBody} updateInterviewSettingsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiUpdateInterviewSettings: async (interviewId: string, orgId: string, updateInterviewSettingsBody: UpdateInterviewSettingsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiUpdateInterviewSettings', 'interviewId', interviewId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('interviewApiUpdateInterviewSettings', 'orgId', orgId)
            // verify required parameter 'updateInterviewSettingsBody' is not null or undefined
            assertParamExists('interviewApiUpdateInterviewSettings', 'updateInterviewSettingsBody', updateInterviewSettingsBody)
            const localVarPath = `/org/{org_id}/interview/{interview_id}/settings`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInterviewSettingsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {File} [reportFile] 
         * @param {string | null} [notes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiUploadGuidanceReport: async (interviewId: string, reportFile?: File, notes?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('interviewApiUploadGuidanceReport', 'interviewId', interviewId)
            const localVarPath = `/admin/guidance/sessions/{interview_id}/report`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (reportFile !== undefined) { 
                localVarFormParams.append('report_file', reportFile as any);
            }

            if (notes !== undefined) { 
                localVarFormParams.append('notes', notes as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InterviewApiApi - functional programming interface
 */
export const InterviewApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InterviewApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} availabilityId 
         * @param {string} orgId 
         * @param {AddSlotsBody} addSlotsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiAddAvailabilitySlots(availabilityId: string, orgId: string, addSlotsBody: AddSlotsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilityDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiAddAvailabilitySlots(availabilityId, orgId, addSlotsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiAddAvailabilitySlots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {string} orgId 
         * @param {string} pid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiAdmitParticipant(interviewId: string, orgId: string, pid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterviewDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiAdmitParticipant(interviewId, orgId, pid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiAdmitParticipant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} availabilityId 
         * @param {BookSlotBody} bookSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiBookAvailabilitySlot(availabilityId: string, bookSlotBody: BookSlotBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Interview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiBookAvailabilitySlot(availabilityId, bookSlotBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiBookAvailabilitySlot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slotId 
         * @param {BookGuidanceSlotBody} bookGuidanceSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiBookGuidanceSlot(slotId: string, bookGuidanceSlotBody: BookGuidanceSlotBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidanceSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiBookGuidanceSlot(slotId, bookGuidanceSlotBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiBookGuidanceSlot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {CancelGuidanceCallBody} cancelGuidanceCallBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiCancelAdminGuidanceCall(interviewId: string, cancelGuidanceCallBody: CancelGuidanceCallBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidanceSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiCancelAdminGuidanceCall(interviewId, cancelGuidanceCallBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiCancelAdminGuidanceCall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiCancelGuidanceReminder(interviewId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidanceSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiCancelGuidanceReminder(interviewId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiCancelGuidanceReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {string} orgId 
         * @param {CancelInterviewBody} cancelInterviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiCancelInterview(interviewId: string, orgId: string, cancelInterviewBody: CancelInterviewBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Interview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiCancelInterview(interviewId, orgId, cancelInterviewBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiCancelInterview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiCancelMyGuidanceCall(interviewId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidanceSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiCancelMyGuidanceCall(interviewId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiCancelMyGuidanceCall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} availabilityId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiCloseAvailability(availabilityId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilityDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiCloseAvailability(availabilityId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiCloseAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateGuidanceSlotsBody} createGuidanceSlotsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiCreateAdminGuidanceSlots(createGuidanceSlotsBody: CreateGuidanceSlotsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateGuidanceSlotsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiCreateAdminGuidanceSlots(createGuidanceSlotsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiCreateAdminGuidanceSlots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateAvailabilityBody} createAvailabilityBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiCreateAvailability(orgId: string, createAvailabilityBody: CreateAvailabilityBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilityDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiCreateAvailability(orgId, createAvailabilityBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiCreateAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateTemplateBody} createTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiCreateAvailabilityTemplate(orgId: string, createTemplateBody: CreateTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilityTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiCreateAvailabilityTemplate(orgId, createTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiCreateAvailabilityTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiDeleteAdminGuidanceSlot(slotId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiDeleteAdminGuidanceSlot(slotId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiDeleteAdminGuidanceSlot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiDeleteAvailabilityTemplate(orgId: string, templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiDeleteAvailabilityTemplate(orgId, templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiDeleteAvailabilityTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {boolean | null} [upcoming] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiGetAdminGuidanceSessions(page?: number, pageSize?: number, upcoming?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGuidanceSessionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiGetAdminGuidanceSessions(page, pageSize, upcoming, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiGetAdminGuidanceSessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [includeAll] 
         * @param {string | null} [meetingType] 
         * @param {string | null} [orgId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [recordingStatus] 
         * @param {string | null} [transcriptStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiGetAdminInterviewRecordings(includeAll?: boolean, meetingType?: string | null, orgId?: string | null, page?: number, pageSize?: number, recordingStatus?: string | null, transcriptStatus?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminRecordingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiGetAdminInterviewRecordings(includeAll, meetingType, orgId, page, pageSize, recordingStatus, transcriptStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiGetAdminInterviewRecordings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiGetAdminInterviewTranscript(interviewId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TranscriptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiGetAdminInterviewTranscript(interviewId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiGetAdminInterviewTranscript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string | null} [jobId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiGetAvailabilities(orgId: string, jobId?: string | null, page?: number, pageSize?: number, status?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAvailabilitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiGetAvailabilities(orgId, jobId, page, pageSize, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiGetAvailabilities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} availabilityId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiGetAvailability(availabilityId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilityDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiGetAvailability(availabilityId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiGetAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} availabilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiGetAvailabilityForCandidate(availabilityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilityCandidateView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiGetAvailabilityForCandidate(availabilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiGetAvailabilityForCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiGetAvailabilityTemplates(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTemplatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiGetAvailabilityTemplates(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiGetAvailabilityTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiGetGuidanceOverview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidanceOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiGetGuidanceOverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiGetGuidanceOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {boolean | null} [consent] 
         * @param {string | null} [displayName] 
         * @param {string | null} [st] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiGetInterview(interviewId: string, consent?: boolean | null, displayName?: string | null, st?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterviewDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiGetInterview(interviewId, consent, displayName, st, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiGetInterview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiGetInterviewRecording(interviewId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecordingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiGetInterviewRecording(interviewId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiGetInterviewRecording']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [jobId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [status] 
         * @param {boolean | null} [upcoming] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiGetMyInterviews(jobId?: string | null, page?: number, pageSize?: number, status?: string | null, upcoming?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInterviewsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiGetMyInterviews(jobId, page, pageSize, status, upcoming, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiGetMyInterviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string | null} [candidateUserId] 
         * @param {string | null} [jobId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [status] 
         * @param {boolean | null} [upcoming] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiGetOrgInterviews(orgId: string, candidateUserId?: string | null, jobId?: string | null, page?: number, pageSize?: number, status?: string | null, upcoming?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInterviewsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiGetOrgInterviews(orgId, candidateUserId, jobId, page, pageSize, status, upcoming, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiGetOrgInterviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {boolean | null} [consent] 
         * @param {string | null} [displayName] 
         * @param {string | null} [st] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiJoinInterview(interviewId: string, consent?: boolean | null, displayName?: string | null, st?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JoinInterviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiJoinInterview(interviewId, consent, displayName, st, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiJoinInterview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {boolean | null} [consent] 
         * @param {string | null} [displayName] 
         * @param {string | null} [st] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiLeaveInterview(interviewId: string, consent?: boolean | null, displayName?: string | null, st?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeaveInterviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiLeaveInterview(interviewId, consent, displayName, st, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiLeaveInterview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiListAdminGuidanceSlots(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGuidanceSlotsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiListAdminGuidanceSlots(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiListAdminGuidanceSlots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiMarkAdminGuidanceNoShow(interviewId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidanceSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiMarkAdminGuidanceNoShow(interviewId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiMarkAdminGuidanceNoShow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} availabilityId 
         * @param {string} orgId 
         * @param {string} slotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiRemoveAvailabilitySlot(availabilityId: string, orgId: string, slotId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilityDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiRemoveAvailabilitySlot(availabilityId, orgId, slotId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiRemoveAvailabilitySlot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {string} orgId 
         * @param {string} pid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiRemoveParticipant(interviewId: string, orgId: string, pid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterviewDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiRemoveParticipant(interviewId, orgId, pid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiRemoveParticipant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {string} orgId 
         * @param {RescheduleInterviewBody} rescheduleInterviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiRescheduleInterview(interviewId: string, orgId: string, rescheduleInterviewBody: RescheduleInterviewBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Interview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiRescheduleInterview(interviewId, orgId, rescheduleInterviewBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiRescheduleInterview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {RescheduleGuidanceBody} rescheduleGuidanceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiRescheduleMyGuidanceCall(interviewId: string, rescheduleGuidanceBody: RescheduleGuidanceBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidanceSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiRescheduleMyGuidanceCall(interviewId, rescheduleGuidanceBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiRescheduleMyGuidanceCall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {RespondInterviewBody} respondInterviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiRespondInterview(interviewId: string, respondInterviewBody: RespondInterviewBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Interview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiRespondInterview(interviewId, respondInterviewBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiRespondInterview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {ScheduleInterviewBody} scheduleInterviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiScheduleInterview(orgId: string, scheduleInterviewBody: ScheduleInterviewBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Interview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiScheduleInterview(orgId, scheduleInterviewBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiScheduleInterview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} availabilityId 
         * @param {string} orgId 
         * @param {SendAvailabilityBody} sendAvailabilityBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiSendAvailability(availabilityId: string, orgId: string, sendAvailabilityBody: SendAvailabilityBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilityDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiSendAvailability(availabilityId, orgId, sendAvailabilityBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiSendAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} templateId 
         * @param {SendFromTemplateBody} sendFromTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiSendAvailabilityFromTemplate(orgId: string, templateId: string, sendFromTemplateBody: SendFromTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilityDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiSendAvailabilityFromTemplate(orgId, templateId, sendFromTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiSendAvailabilityFromTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {SendGuidanceReminderBody} sendGuidanceReminderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiSendGuidanceJoinReminder(interviewId: string, sendGuidanceReminderBody: SendGuidanceReminderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidanceSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiSendGuidanceJoinReminder(interviewId, sendGuidanceReminderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiSendGuidanceJoinReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SetGuidanceConfigBody} setGuidanceConfigBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiSetAdminGuidanceConfig(setGuidanceConfigBody: SetGuidanceConfigBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidanceConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiSetAdminGuidanceConfig(setGuidanceConfigBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiSetAdminGuidanceConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiUnlockInterviewRecording(interviewId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecordingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiUnlockInterviewRecording(interviewId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiUnlockInterviewRecording']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} templateId 
         * @param {UpdateTemplateBody} updateTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiUpdateAvailabilityTemplate(orgId: string, templateId: string, updateTemplateBody: UpdateTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilityTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiUpdateAvailabilityTemplate(orgId, templateId, updateTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiUpdateAvailabilityTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {string} orgId 
         * @param {UpdateInterviewSettingsBody} updateInterviewSettingsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiUpdateInterviewSettings(interviewId: string, orgId: string, updateInterviewSettingsBody: UpdateInterviewSettingsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Interview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiUpdateInterviewSettings(interviewId, orgId, updateInterviewSettingsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiUpdateInterviewSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {File} [reportFile] 
         * @param {string | null} [notes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async interviewApiUploadGuidanceReport(interviewId: string, reportFile?: File, notes?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidanceSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.interviewApiUploadGuidanceReport(interviewId, reportFile, notes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewApiApi.interviewApiUploadGuidanceReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InterviewApiApi - factory interface
 */
export const InterviewApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InterviewApiApiFp(configuration)
    return {
        /**
         * 
         * @param {InterviewApiApiInterviewApiAddAvailabilitySlotsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiAddAvailabilitySlots(requestParameters: InterviewApiApiInterviewApiAddAvailabilitySlotsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AvailabilityDetailResponse> {
            return localVarFp.interviewApiAddAvailabilitySlots(requestParameters.availabilityId, requestParameters.orgId, requestParameters.addSlotsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiAdmitParticipantRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiAdmitParticipant(requestParameters: InterviewApiApiInterviewApiAdmitParticipantRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterviewDetailResponse> {
            return localVarFp.interviewApiAdmitParticipant(requestParameters.interviewId, requestParameters.orgId, requestParameters.pid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiBookAvailabilitySlotRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiBookAvailabilitySlot(requestParameters: InterviewApiApiInterviewApiBookAvailabilitySlotRequest, options?: RawAxiosRequestConfig): AxiosPromise<Interview> {
            return localVarFp.interviewApiBookAvailabilitySlot(requestParameters.availabilityId, requestParameters.bookSlotBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiBookGuidanceSlotRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiBookGuidanceSlot(requestParameters: InterviewApiApiInterviewApiBookGuidanceSlotRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuidanceSession> {
            return localVarFp.interviewApiBookGuidanceSlot(requestParameters.slotId, requestParameters.bookGuidanceSlotBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiCancelAdminGuidanceCallRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiCancelAdminGuidanceCall(requestParameters: InterviewApiApiInterviewApiCancelAdminGuidanceCallRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuidanceSession> {
            return localVarFp.interviewApiCancelAdminGuidanceCall(requestParameters.interviewId, requestParameters.cancelGuidanceCallBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiCancelGuidanceReminderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiCancelGuidanceReminder(requestParameters: InterviewApiApiInterviewApiCancelGuidanceReminderRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuidanceSession> {
            return localVarFp.interviewApiCancelGuidanceReminder(requestParameters.interviewId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiCancelInterviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiCancelInterview(requestParameters: InterviewApiApiInterviewApiCancelInterviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<Interview> {
            return localVarFp.interviewApiCancelInterview(requestParameters.interviewId, requestParameters.orgId, requestParameters.cancelInterviewBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiCancelMyGuidanceCallRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiCancelMyGuidanceCall(requestParameters: InterviewApiApiInterviewApiCancelMyGuidanceCallRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuidanceSession> {
            return localVarFp.interviewApiCancelMyGuidanceCall(requestParameters.interviewId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiCloseAvailabilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiCloseAvailability(requestParameters: InterviewApiApiInterviewApiCloseAvailabilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<AvailabilityDetailResponse> {
            return localVarFp.interviewApiCloseAvailability(requestParameters.availabilityId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiCreateAdminGuidanceSlotsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiCreateAdminGuidanceSlots(requestParameters: InterviewApiApiInterviewApiCreateAdminGuidanceSlotsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateGuidanceSlotsResponse> {
            return localVarFp.interviewApiCreateAdminGuidanceSlots(requestParameters.createGuidanceSlotsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiCreateAvailabilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiCreateAvailability(requestParameters: InterviewApiApiInterviewApiCreateAvailabilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<AvailabilityDetailResponse> {
            return localVarFp.interviewApiCreateAvailability(requestParameters.orgId, requestParameters.createAvailabilityBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiCreateAvailabilityTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiCreateAvailabilityTemplate(requestParameters: InterviewApiApiInterviewApiCreateAvailabilityTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<AvailabilityTemplateResponse> {
            return localVarFp.interviewApiCreateAvailabilityTemplate(requestParameters.orgId, requestParameters.createTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiDeleteAdminGuidanceSlotRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiDeleteAdminGuidanceSlot(requestParameters: InterviewApiApiInterviewApiDeleteAdminGuidanceSlotRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.interviewApiDeleteAdminGuidanceSlot(requestParameters.slotId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiDeleteAvailabilityTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiDeleteAvailabilityTemplate(requestParameters: InterviewApiApiInterviewApiDeleteAvailabilityTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.interviewApiDeleteAvailabilityTemplate(requestParameters.orgId, requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiGetAdminGuidanceSessionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetAdminGuidanceSessions(requestParameters: InterviewApiApiInterviewApiGetAdminGuidanceSessionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetGuidanceSessionsResponse> {
            return localVarFp.interviewApiGetAdminGuidanceSessions(requestParameters.page, requestParameters.pageSize, requestParameters.upcoming, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiGetAdminInterviewRecordingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetAdminInterviewRecordings(requestParameters: InterviewApiApiInterviewApiGetAdminInterviewRecordingsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminRecordingsResponse> {
            return localVarFp.interviewApiGetAdminInterviewRecordings(requestParameters.includeAll, requestParameters.meetingType, requestParameters.orgId, requestParameters.page, requestParameters.pageSize, requestParameters.recordingStatus, requestParameters.transcriptStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiGetAdminInterviewTranscriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetAdminInterviewTranscript(requestParameters: InterviewApiApiInterviewApiGetAdminInterviewTranscriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<TranscriptResponse> {
            return localVarFp.interviewApiGetAdminInterviewTranscript(requestParameters.interviewId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiGetAvailabilitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetAvailabilities(requestParameters: InterviewApiApiInterviewApiGetAvailabilitiesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAvailabilitiesResponse> {
            return localVarFp.interviewApiGetAvailabilities(requestParameters.orgId, requestParameters.jobId, requestParameters.page, requestParameters.pageSize, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiGetAvailabilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetAvailability(requestParameters: InterviewApiApiInterviewApiGetAvailabilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<AvailabilityDetailResponse> {
            return localVarFp.interviewApiGetAvailability(requestParameters.availabilityId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiGetAvailabilityForCandidateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetAvailabilityForCandidate(requestParameters: InterviewApiApiInterviewApiGetAvailabilityForCandidateRequest, options?: RawAxiosRequestConfig): AxiosPromise<AvailabilityCandidateView> {
            return localVarFp.interviewApiGetAvailabilityForCandidate(requestParameters.availabilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiGetAvailabilityTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetAvailabilityTemplates(requestParameters: InterviewApiApiInterviewApiGetAvailabilityTemplatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetTemplatesResponse> {
            return localVarFp.interviewApiGetAvailabilityTemplates(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetGuidanceOverview(options?: RawAxiosRequestConfig): AxiosPromise<GuidanceOverviewResponse> {
            return localVarFp.interviewApiGetGuidanceOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiGetInterviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetInterview(requestParameters: InterviewApiApiInterviewApiGetInterviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterviewDetailResponse> {
            return localVarFp.interviewApiGetInterview(requestParameters.interviewId, requestParameters.consent, requestParameters.displayName, requestParameters.st, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiGetInterviewRecordingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetInterviewRecording(requestParameters: InterviewApiApiInterviewApiGetInterviewRecordingRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecordingResponse> {
            return localVarFp.interviewApiGetInterviewRecording(requestParameters.interviewId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiGetMyInterviewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetMyInterviews(requestParameters: InterviewApiApiInterviewApiGetMyInterviewsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetInterviewsResponse> {
            return localVarFp.interviewApiGetMyInterviews(requestParameters.jobId, requestParameters.page, requestParameters.pageSize, requestParameters.status, requestParameters.upcoming, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiGetOrgInterviewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiGetOrgInterviews(requestParameters: InterviewApiApiInterviewApiGetOrgInterviewsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetInterviewsResponse> {
            return localVarFp.interviewApiGetOrgInterviews(requestParameters.orgId, requestParameters.candidateUserId, requestParameters.jobId, requestParameters.page, requestParameters.pageSize, requestParameters.status, requestParameters.upcoming, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiJoinInterviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiJoinInterview(requestParameters: InterviewApiApiInterviewApiJoinInterviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<JoinInterviewResponse> {
            return localVarFp.interviewApiJoinInterview(requestParameters.interviewId, requestParameters.consent, requestParameters.displayName, requestParameters.st, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiLeaveInterviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiLeaveInterview(requestParameters: InterviewApiApiInterviewApiLeaveInterviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<LeaveInterviewResponse> {
            return localVarFp.interviewApiLeaveInterview(requestParameters.interviewId, requestParameters.consent, requestParameters.displayName, requestParameters.st, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiListAdminGuidanceSlots(options?: RawAxiosRequestConfig): AxiosPromise<GetGuidanceSlotsResponse> {
            return localVarFp.interviewApiListAdminGuidanceSlots(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiMarkAdminGuidanceNoShowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiMarkAdminGuidanceNoShow(requestParameters: InterviewApiApiInterviewApiMarkAdminGuidanceNoShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuidanceSession> {
            return localVarFp.interviewApiMarkAdminGuidanceNoShow(requestParameters.interviewId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiRemoveAvailabilitySlotRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiRemoveAvailabilitySlot(requestParameters: InterviewApiApiInterviewApiRemoveAvailabilitySlotRequest, options?: RawAxiosRequestConfig): AxiosPromise<AvailabilityDetailResponse> {
            return localVarFp.interviewApiRemoveAvailabilitySlot(requestParameters.availabilityId, requestParameters.orgId, requestParameters.slotId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiRemoveParticipantRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiRemoveParticipant(requestParameters: InterviewApiApiInterviewApiRemoveParticipantRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterviewDetailResponse> {
            return localVarFp.interviewApiRemoveParticipant(requestParameters.interviewId, requestParameters.orgId, requestParameters.pid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiRescheduleInterviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiRescheduleInterview(requestParameters: InterviewApiApiInterviewApiRescheduleInterviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<Interview> {
            return localVarFp.interviewApiRescheduleInterview(requestParameters.interviewId, requestParameters.orgId, requestParameters.rescheduleInterviewBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiRescheduleMyGuidanceCallRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiRescheduleMyGuidanceCall(requestParameters: InterviewApiApiInterviewApiRescheduleMyGuidanceCallRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuidanceSession> {
            return localVarFp.interviewApiRescheduleMyGuidanceCall(requestParameters.interviewId, requestParameters.rescheduleGuidanceBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiRespondInterviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiRespondInterview(requestParameters: InterviewApiApiInterviewApiRespondInterviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<Interview> {
            return localVarFp.interviewApiRespondInterview(requestParameters.interviewId, requestParameters.respondInterviewBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiScheduleInterviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiScheduleInterview(requestParameters: InterviewApiApiInterviewApiScheduleInterviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<Interview> {
            return localVarFp.interviewApiScheduleInterview(requestParameters.orgId, requestParameters.scheduleInterviewBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiSendAvailabilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiSendAvailability(requestParameters: InterviewApiApiInterviewApiSendAvailabilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<AvailabilityDetailResponse> {
            return localVarFp.interviewApiSendAvailability(requestParameters.availabilityId, requestParameters.orgId, requestParameters.sendAvailabilityBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiSendAvailabilityFromTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiSendAvailabilityFromTemplate(requestParameters: InterviewApiApiInterviewApiSendAvailabilityFromTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<AvailabilityDetailResponse> {
            return localVarFp.interviewApiSendAvailabilityFromTemplate(requestParameters.orgId, requestParameters.templateId, requestParameters.sendFromTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiSendGuidanceJoinReminderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiSendGuidanceJoinReminder(requestParameters: InterviewApiApiInterviewApiSendGuidanceJoinReminderRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuidanceSession> {
            return localVarFp.interviewApiSendGuidanceJoinReminder(requestParameters.interviewId, requestParameters.sendGuidanceReminderBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiSetAdminGuidanceConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiSetAdminGuidanceConfig(requestParameters: InterviewApiApiInterviewApiSetAdminGuidanceConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuidanceConfigResponse> {
            return localVarFp.interviewApiSetAdminGuidanceConfig(requestParameters.setGuidanceConfigBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiUnlockInterviewRecordingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiUnlockInterviewRecording(requestParameters: InterviewApiApiInterviewApiUnlockInterviewRecordingRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecordingResponse> {
            return localVarFp.interviewApiUnlockInterviewRecording(requestParameters.interviewId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiUpdateAvailabilityTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiUpdateAvailabilityTemplate(requestParameters: InterviewApiApiInterviewApiUpdateAvailabilityTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<AvailabilityTemplateResponse> {
            return localVarFp.interviewApiUpdateAvailabilityTemplate(requestParameters.orgId, requestParameters.templateId, requestParameters.updateTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiUpdateInterviewSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiUpdateInterviewSettings(requestParameters: InterviewApiApiInterviewApiUpdateInterviewSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Interview> {
            return localVarFp.interviewApiUpdateInterviewSettings(requestParameters.interviewId, requestParameters.orgId, requestParameters.updateInterviewSettingsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterviewApiApiInterviewApiUploadGuidanceReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interviewApiUploadGuidanceReport(requestParameters: InterviewApiApiInterviewApiUploadGuidanceReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuidanceSession> {
            return localVarFp.interviewApiUploadGuidanceReport(requestParameters.interviewId, requestParameters.reportFile, requestParameters.notes, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for interviewApiAddAvailabilitySlots operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiAddAvailabilitySlotsRequest {
    readonly availabilityId: string

    readonly orgId: string

    readonly addSlotsBody: AddSlotsBody
}

/**
 * Request parameters for interviewApiAdmitParticipant operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiAdmitParticipantRequest {
    readonly interviewId: string

    readonly orgId: string

    readonly pid: string
}

/**
 * Request parameters for interviewApiBookAvailabilitySlot operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiBookAvailabilitySlotRequest {
    readonly availabilityId: string

    readonly bookSlotBody: BookSlotBody
}

/**
 * Request parameters for interviewApiBookGuidanceSlot operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiBookGuidanceSlotRequest {
    readonly slotId: string

    readonly bookGuidanceSlotBody: BookGuidanceSlotBody
}

/**
 * Request parameters for interviewApiCancelAdminGuidanceCall operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiCancelAdminGuidanceCallRequest {
    readonly interviewId: string

    readonly cancelGuidanceCallBody: CancelGuidanceCallBody
}

/**
 * Request parameters for interviewApiCancelGuidanceReminder operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiCancelGuidanceReminderRequest {
    readonly interviewId: string
}

/**
 * Request parameters for interviewApiCancelInterview operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiCancelInterviewRequest {
    readonly interviewId: string

    readonly orgId: string

    readonly cancelInterviewBody: CancelInterviewBody
}

/**
 * Request parameters for interviewApiCancelMyGuidanceCall operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiCancelMyGuidanceCallRequest {
    readonly interviewId: string
}

/**
 * Request parameters for interviewApiCloseAvailability operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiCloseAvailabilityRequest {
    readonly availabilityId: string

    readonly orgId: string
}

/**
 * Request parameters for interviewApiCreateAdminGuidanceSlots operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiCreateAdminGuidanceSlotsRequest {
    readonly createGuidanceSlotsBody: CreateGuidanceSlotsBody
}

/**
 * Request parameters for interviewApiCreateAvailability operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiCreateAvailabilityRequest {
    readonly orgId: string

    readonly createAvailabilityBody: CreateAvailabilityBody
}

/**
 * Request parameters for interviewApiCreateAvailabilityTemplate operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiCreateAvailabilityTemplateRequest {
    readonly orgId: string

    readonly createTemplateBody: CreateTemplateBody
}

/**
 * Request parameters for interviewApiDeleteAdminGuidanceSlot operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiDeleteAdminGuidanceSlotRequest {
    readonly slotId: string
}

/**
 * Request parameters for interviewApiDeleteAvailabilityTemplate operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiDeleteAvailabilityTemplateRequest {
    readonly orgId: string

    readonly templateId: string
}

/**
 * Request parameters for interviewApiGetAdminGuidanceSessions operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiGetAdminGuidanceSessionsRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly upcoming?: boolean | null
}

/**
 * Request parameters for interviewApiGetAdminInterviewRecordings operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiGetAdminInterviewRecordingsRequest {
    readonly includeAll?: boolean

    readonly meetingType?: string | null

    readonly orgId?: string | null

    readonly page?: number

    readonly pageSize?: number

    readonly recordingStatus?: string | null

    readonly transcriptStatus?: string | null
}

/**
 * Request parameters for interviewApiGetAdminInterviewTranscript operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiGetAdminInterviewTranscriptRequest {
    readonly interviewId: string
}

/**
 * Request parameters for interviewApiGetAvailabilities operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiGetAvailabilitiesRequest {
    readonly orgId: string

    readonly jobId?: string | null

    readonly page?: number

    readonly pageSize?: number

    readonly status?: string | null
}

/**
 * Request parameters for interviewApiGetAvailability operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiGetAvailabilityRequest {
    readonly availabilityId: string

    readonly orgId: string
}

/**
 * Request parameters for interviewApiGetAvailabilityForCandidate operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiGetAvailabilityForCandidateRequest {
    readonly availabilityId: string
}

/**
 * Request parameters for interviewApiGetAvailabilityTemplates operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiGetAvailabilityTemplatesRequest {
    readonly orgId: string
}

/**
 * Request parameters for interviewApiGetInterview operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiGetInterviewRequest {
    readonly interviewId: string

    readonly consent?: boolean | null

    readonly displayName?: string | null

    readonly st?: string | null
}

/**
 * Request parameters for interviewApiGetInterviewRecording operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiGetInterviewRecordingRequest {
    readonly interviewId: string

    readonly orgId: string
}

/**
 * Request parameters for interviewApiGetMyInterviews operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiGetMyInterviewsRequest {
    readonly jobId?: string | null

    readonly page?: number

    readonly pageSize?: number

    readonly status?: string | null

    readonly upcoming?: boolean | null
}

/**
 * Request parameters for interviewApiGetOrgInterviews operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiGetOrgInterviewsRequest {
    readonly orgId: string

    readonly candidateUserId?: string | null

    readonly jobId?: string | null

    readonly page?: number

    readonly pageSize?: number

    readonly status?: string | null

    readonly upcoming?: boolean | null
}

/**
 * Request parameters for interviewApiJoinInterview operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiJoinInterviewRequest {
    readonly interviewId: string

    readonly consent?: boolean | null

    readonly displayName?: string | null

    readonly st?: string | null
}

/**
 * Request parameters for interviewApiLeaveInterview operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiLeaveInterviewRequest {
    readonly interviewId: string

    readonly consent?: boolean | null

    readonly displayName?: string | null

    readonly st?: string | null
}

/**
 * Request parameters for interviewApiMarkAdminGuidanceNoShow operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiMarkAdminGuidanceNoShowRequest {
    readonly interviewId: string
}

/**
 * Request parameters for interviewApiRemoveAvailabilitySlot operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiRemoveAvailabilitySlotRequest {
    readonly availabilityId: string

    readonly orgId: string

    readonly slotId: string
}

/**
 * Request parameters for interviewApiRemoveParticipant operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiRemoveParticipantRequest {
    readonly interviewId: string

    readonly orgId: string

    readonly pid: string
}

/**
 * Request parameters for interviewApiRescheduleInterview operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiRescheduleInterviewRequest {
    readonly interviewId: string

    readonly orgId: string

    readonly rescheduleInterviewBody: RescheduleInterviewBody
}

/**
 * Request parameters for interviewApiRescheduleMyGuidanceCall operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiRescheduleMyGuidanceCallRequest {
    readonly interviewId: string

    readonly rescheduleGuidanceBody: RescheduleGuidanceBody
}

/**
 * Request parameters for interviewApiRespondInterview operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiRespondInterviewRequest {
    readonly interviewId: string

    readonly respondInterviewBody: RespondInterviewBody
}

/**
 * Request parameters for interviewApiScheduleInterview operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiScheduleInterviewRequest {
    readonly orgId: string

    readonly scheduleInterviewBody: ScheduleInterviewBody
}

/**
 * Request parameters for interviewApiSendAvailability operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiSendAvailabilityRequest {
    readonly availabilityId: string

    readonly orgId: string

    readonly sendAvailabilityBody: SendAvailabilityBody
}

/**
 * Request parameters for interviewApiSendAvailabilityFromTemplate operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiSendAvailabilityFromTemplateRequest {
    readonly orgId: string

    readonly templateId: string

    readonly sendFromTemplateBody: SendFromTemplateBody
}

/**
 * Request parameters for interviewApiSendGuidanceJoinReminder operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiSendGuidanceJoinReminderRequest {
    readonly interviewId: string

    readonly sendGuidanceReminderBody: SendGuidanceReminderBody
}

/**
 * Request parameters for interviewApiSetAdminGuidanceConfig operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiSetAdminGuidanceConfigRequest {
    readonly setGuidanceConfigBody: SetGuidanceConfigBody
}

/**
 * Request parameters for interviewApiUnlockInterviewRecording operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiUnlockInterviewRecordingRequest {
    readonly interviewId: string

    readonly orgId: string
}

/**
 * Request parameters for interviewApiUpdateAvailabilityTemplate operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiUpdateAvailabilityTemplateRequest {
    readonly orgId: string

    readonly templateId: string

    readonly updateTemplateBody: UpdateTemplateBody
}

/**
 * Request parameters for interviewApiUpdateInterviewSettings operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiUpdateInterviewSettingsRequest {
    readonly interviewId: string

    readonly orgId: string

    readonly updateInterviewSettingsBody: UpdateInterviewSettingsBody
}

/**
 * Request parameters for interviewApiUploadGuidanceReport operation in InterviewApiApi.
 */
export interface InterviewApiApiInterviewApiUploadGuidanceReportRequest {
    readonly interviewId: string

    readonly reportFile?: File

    readonly notes?: string | null
}

/**
 * InterviewApiApi - object-oriented interface
 */
export class InterviewApiApi extends BaseAPI {
    /**
     * 
     * @param {InterviewApiApiInterviewApiAddAvailabilitySlotsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiAddAvailabilitySlots(requestParameters: InterviewApiApiInterviewApiAddAvailabilitySlotsRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiAddAvailabilitySlots(requestParameters.availabilityId, requestParameters.orgId, requestParameters.addSlotsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiAdmitParticipantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiAdmitParticipant(requestParameters: InterviewApiApiInterviewApiAdmitParticipantRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiAdmitParticipant(requestParameters.interviewId, requestParameters.orgId, requestParameters.pid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiBookAvailabilitySlotRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiBookAvailabilitySlot(requestParameters: InterviewApiApiInterviewApiBookAvailabilitySlotRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiBookAvailabilitySlot(requestParameters.availabilityId, requestParameters.bookSlotBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiBookGuidanceSlotRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiBookGuidanceSlot(requestParameters: InterviewApiApiInterviewApiBookGuidanceSlotRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiBookGuidanceSlot(requestParameters.slotId, requestParameters.bookGuidanceSlotBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiCancelAdminGuidanceCallRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiCancelAdminGuidanceCall(requestParameters: InterviewApiApiInterviewApiCancelAdminGuidanceCallRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiCancelAdminGuidanceCall(requestParameters.interviewId, requestParameters.cancelGuidanceCallBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiCancelGuidanceReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiCancelGuidanceReminder(requestParameters: InterviewApiApiInterviewApiCancelGuidanceReminderRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiCancelGuidanceReminder(requestParameters.interviewId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiCancelInterviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiCancelInterview(requestParameters: InterviewApiApiInterviewApiCancelInterviewRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiCancelInterview(requestParameters.interviewId, requestParameters.orgId, requestParameters.cancelInterviewBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiCancelMyGuidanceCallRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiCancelMyGuidanceCall(requestParameters: InterviewApiApiInterviewApiCancelMyGuidanceCallRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiCancelMyGuidanceCall(requestParameters.interviewId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiCloseAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiCloseAvailability(requestParameters: InterviewApiApiInterviewApiCloseAvailabilityRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiCloseAvailability(requestParameters.availabilityId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiCreateAdminGuidanceSlotsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiCreateAdminGuidanceSlots(requestParameters: InterviewApiApiInterviewApiCreateAdminGuidanceSlotsRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiCreateAdminGuidanceSlots(requestParameters.createGuidanceSlotsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiCreateAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiCreateAvailability(requestParameters: InterviewApiApiInterviewApiCreateAvailabilityRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiCreateAvailability(requestParameters.orgId, requestParameters.createAvailabilityBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiCreateAvailabilityTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiCreateAvailabilityTemplate(requestParameters: InterviewApiApiInterviewApiCreateAvailabilityTemplateRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiCreateAvailabilityTemplate(requestParameters.orgId, requestParameters.createTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiDeleteAdminGuidanceSlotRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiDeleteAdminGuidanceSlot(requestParameters: InterviewApiApiInterviewApiDeleteAdminGuidanceSlotRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiDeleteAdminGuidanceSlot(requestParameters.slotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiDeleteAvailabilityTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiDeleteAvailabilityTemplate(requestParameters: InterviewApiApiInterviewApiDeleteAvailabilityTemplateRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiDeleteAvailabilityTemplate(requestParameters.orgId, requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiGetAdminGuidanceSessionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiGetAdminGuidanceSessions(requestParameters: InterviewApiApiInterviewApiGetAdminGuidanceSessionsRequest = {}, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiGetAdminGuidanceSessions(requestParameters.page, requestParameters.pageSize, requestParameters.upcoming, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiGetAdminInterviewRecordingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiGetAdminInterviewRecordings(requestParameters: InterviewApiApiInterviewApiGetAdminInterviewRecordingsRequest = {}, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiGetAdminInterviewRecordings(requestParameters.includeAll, requestParameters.meetingType, requestParameters.orgId, requestParameters.page, requestParameters.pageSize, requestParameters.recordingStatus, requestParameters.transcriptStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiGetAdminInterviewTranscriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiGetAdminInterviewTranscript(requestParameters: InterviewApiApiInterviewApiGetAdminInterviewTranscriptRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiGetAdminInterviewTranscript(requestParameters.interviewId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiGetAvailabilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiGetAvailabilities(requestParameters: InterviewApiApiInterviewApiGetAvailabilitiesRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiGetAvailabilities(requestParameters.orgId, requestParameters.jobId, requestParameters.page, requestParameters.pageSize, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiGetAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiGetAvailability(requestParameters: InterviewApiApiInterviewApiGetAvailabilityRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiGetAvailability(requestParameters.availabilityId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiGetAvailabilityForCandidateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiGetAvailabilityForCandidate(requestParameters: InterviewApiApiInterviewApiGetAvailabilityForCandidateRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiGetAvailabilityForCandidate(requestParameters.availabilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiGetAvailabilityTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiGetAvailabilityTemplates(requestParameters: InterviewApiApiInterviewApiGetAvailabilityTemplatesRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiGetAvailabilityTemplates(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiGetGuidanceOverview(options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiGetGuidanceOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiGetInterviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiGetInterview(requestParameters: InterviewApiApiInterviewApiGetInterviewRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiGetInterview(requestParameters.interviewId, requestParameters.consent, requestParameters.displayName, requestParameters.st, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiGetInterviewRecordingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiGetInterviewRecording(requestParameters: InterviewApiApiInterviewApiGetInterviewRecordingRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiGetInterviewRecording(requestParameters.interviewId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiGetMyInterviewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiGetMyInterviews(requestParameters: InterviewApiApiInterviewApiGetMyInterviewsRequest = {}, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiGetMyInterviews(requestParameters.jobId, requestParameters.page, requestParameters.pageSize, requestParameters.status, requestParameters.upcoming, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiGetOrgInterviewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiGetOrgInterviews(requestParameters: InterviewApiApiInterviewApiGetOrgInterviewsRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiGetOrgInterviews(requestParameters.orgId, requestParameters.candidateUserId, requestParameters.jobId, requestParameters.page, requestParameters.pageSize, requestParameters.status, requestParameters.upcoming, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiJoinInterviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiJoinInterview(requestParameters: InterviewApiApiInterviewApiJoinInterviewRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiJoinInterview(requestParameters.interviewId, requestParameters.consent, requestParameters.displayName, requestParameters.st, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiLeaveInterviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiLeaveInterview(requestParameters: InterviewApiApiInterviewApiLeaveInterviewRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiLeaveInterview(requestParameters.interviewId, requestParameters.consent, requestParameters.displayName, requestParameters.st, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiListAdminGuidanceSlots(options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiListAdminGuidanceSlots(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiMarkAdminGuidanceNoShowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiMarkAdminGuidanceNoShow(requestParameters: InterviewApiApiInterviewApiMarkAdminGuidanceNoShowRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiMarkAdminGuidanceNoShow(requestParameters.interviewId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiRemoveAvailabilitySlotRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiRemoveAvailabilitySlot(requestParameters: InterviewApiApiInterviewApiRemoveAvailabilitySlotRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiRemoveAvailabilitySlot(requestParameters.availabilityId, requestParameters.orgId, requestParameters.slotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiRemoveParticipantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiRemoveParticipant(requestParameters: InterviewApiApiInterviewApiRemoveParticipantRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiRemoveParticipant(requestParameters.interviewId, requestParameters.orgId, requestParameters.pid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiRescheduleInterviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiRescheduleInterview(requestParameters: InterviewApiApiInterviewApiRescheduleInterviewRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiRescheduleInterview(requestParameters.interviewId, requestParameters.orgId, requestParameters.rescheduleInterviewBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiRescheduleMyGuidanceCallRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiRescheduleMyGuidanceCall(requestParameters: InterviewApiApiInterviewApiRescheduleMyGuidanceCallRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiRescheduleMyGuidanceCall(requestParameters.interviewId, requestParameters.rescheduleGuidanceBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiRespondInterviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiRespondInterview(requestParameters: InterviewApiApiInterviewApiRespondInterviewRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiRespondInterview(requestParameters.interviewId, requestParameters.respondInterviewBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiScheduleInterviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiScheduleInterview(requestParameters: InterviewApiApiInterviewApiScheduleInterviewRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiScheduleInterview(requestParameters.orgId, requestParameters.scheduleInterviewBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiSendAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiSendAvailability(requestParameters: InterviewApiApiInterviewApiSendAvailabilityRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiSendAvailability(requestParameters.availabilityId, requestParameters.orgId, requestParameters.sendAvailabilityBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiSendAvailabilityFromTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiSendAvailabilityFromTemplate(requestParameters: InterviewApiApiInterviewApiSendAvailabilityFromTemplateRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiSendAvailabilityFromTemplate(requestParameters.orgId, requestParameters.templateId, requestParameters.sendFromTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiSendGuidanceJoinReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiSendGuidanceJoinReminder(requestParameters: InterviewApiApiInterviewApiSendGuidanceJoinReminderRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiSendGuidanceJoinReminder(requestParameters.interviewId, requestParameters.sendGuidanceReminderBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiSetAdminGuidanceConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiSetAdminGuidanceConfig(requestParameters: InterviewApiApiInterviewApiSetAdminGuidanceConfigRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiSetAdminGuidanceConfig(requestParameters.setGuidanceConfigBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiUnlockInterviewRecordingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiUnlockInterviewRecording(requestParameters: InterviewApiApiInterviewApiUnlockInterviewRecordingRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiUnlockInterviewRecording(requestParameters.interviewId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiUpdateAvailabilityTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiUpdateAvailabilityTemplate(requestParameters: InterviewApiApiInterviewApiUpdateAvailabilityTemplateRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiUpdateAvailabilityTemplate(requestParameters.orgId, requestParameters.templateId, requestParameters.updateTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiUpdateInterviewSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiUpdateInterviewSettings(requestParameters: InterviewApiApiInterviewApiUpdateInterviewSettingsRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiUpdateInterviewSettings(requestParameters.interviewId, requestParameters.orgId, requestParameters.updateInterviewSettingsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterviewApiApiInterviewApiUploadGuidanceReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public interviewApiUploadGuidanceReport(requestParameters: InterviewApiApiInterviewApiUploadGuidanceReportRequest, options?: RawAxiosRequestConfig) {
        return InterviewApiApiFp(this.configuration).interviewApiUploadGuidanceReport(requestParameters.interviewId, requestParameters.reportFile, requestParameters.notes, options).then((request) => request(this.axios, this.basePath));
    }
}

